
export const environment = {
  production: false,
  apiBaseUrl: "https://api-lms-envx.project-ashton.com/",
  baseUrl: "https://api-lms-envx.project-ashton.com/v2/user_management",
  resetPassword: '/change_password/',
  login: "https://api-lms-envx.project-ashton.com/v2/user_authentication/get_token",
  ForgotPassworLink: '/forgot_password_link/',
  ForgotPasswor: '/reset_password',
  passwordGuildelines: '/get_passwordguidelines',
  redirectUrl: 'http://localhost:4200/#/landing',
  lamdaUrl: "https://7b3lp7v6a9.execute-api.eu-central-1.amazonaws.com/dev/um-extended-apis/",
  authentication: "https://api-lms-envx.project-ashton.com/v2/auth_management/",
  lmsEndpoint: '/',
  cookieExpiryDays: 7,
  identityProvider: 'lms-envx',
  opco: 'lms-rc-dev',
  local: true,
  getUserTypeUri: 'user_management/get_user_userType',
  auth0: {
    authority: 'https://dev.login.lifesciences.danaher.com',
    clientId: 'fFR5Q3F3kGaOWIzNI2ueNichhKvtnjIr',
    scope: 'openid profile email offline_access'
  }
};
